const FAQData = [
    {
        question: "What is JavaScript ?",
        answer: "JavaScript, often abbreviated as JS, is a programming language that confirms to the ECMAScript specificaion. JavaScript is high-level, often just-in-timecompiled, and multi-paradigm."
    },
    {
        question: "Is it easy to learn HTML and CSS ?",
        answer: "HTML and CSS are partners that work together to create web pages. and while they might be team mates, HTML and CSS visualy look different, and they function differently too. So while you'll have to learn both, it's easy to learn HTML and CSS together at the same time. They aren't hard."
    },
    {
        question: "What is Web Development ?",
        answer: "Web Development is the building and maintainance of websites, it's the work that happens behind the scenes to make a website look great, work fast and perform well with a seamless user experience."
    },
]

export default FAQData